import moment from 'moment';

class ComplementoDonatariasRequestInputTransformer {
  getName() {
    return 'Donatarias';
  }

  make(input) {
    const { Complemento } = input;

    if (!Complemento || !Complemento.Donatarias) {
      return input;
    }

    const { Donatarias } = Complemento;

    input.Complemento = {
      ...Complemento,
      Donatarias: {
        ...Donatarias,
        version: '1.1',
        fechaAutorizacion: moment(Donatarias.fechaAutorizacion).format('YYYY-MM-DD'),
      },
    };

    return input;
  }
}

export default ComplementoDonatariasRequestInputTransformer;
